import { useEffect, useRef, useState } from "react";
import { Modal } from "../../common/components/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CopyToClipboard } from "../../../utils/CommonHelper";
// import { ResolveArrayNull } from "../../../../../utils/CommonHelper";
import { Dialog } from "@mui/material";
import SweetAlert2 from "react-sweetalert2";
import { useAuth } from "./AuthInit";
import { fetchIPAddress } from "../api/loginapi";
import * as actions from "../../common/redux/MasterLayoutAction";

export const ChatDialog = ({}) => {
  const intl = useIntl();
  const dismissBtnRef = useRef();
  const [swalProps, setSwalProps] = useState({});
  const formikRef = useRef();
  const [open, setOpen] = useState(false);
  const [chatLink, setChatLink] = useState("");
  const dispatch = useDispatch();
  const { auth } = useAuth();

  const masterLayoutState = useSelector(
    ({ masterLayout }) => masterLayout,
    shallowEqual
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handlNew = () => {
    window.open(chatLink);
    setOpen(false);
  };
  useEffect(() => {
    fetchIPAddress().then((res) => {
      const ipaddress = res.ip;
      localStorage.setItem("ipaddress", ipaddress);
      dispatch(
        actions.getContactLists({
          ipaddress: res.ip,
          currencycode: auth?.currencycode ?? "",
        })
      );
    });
  }, []);

  const handleContactClick = (urllink, contacttype) => {
    const constructCustomerServiceLink = () =>
      contacttype === "Whatsapp"
        ? `${urllink}?text=Hi%20279RC%20Customer%20Service%20`
        : urllink;

    const customerServiceLink = constructCustomerServiceLink();
    setChatLink(customerServiceLink);
    if (sessionStorage.getItem("platform") === "mobile") {
      console.log(`customerservice: ${customerServiceLink}`);
      sessionStorage.setItem("customerServiceLink", customerServiceLink);
    } else {
      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );
      if (isSafari || sessionStorage.getItem("platform") === "telegram") {
        setOpen(true);
      } else {
        window.open(customerServiceLink);
      }
    }
  };

  return (
    <Modal
      modalId="chatModal"
      title={intl.formatMessage({ id: "liveChat" })}
      dismissBtnRef={dismissBtnRef}
    >
      <SweetAlert2
        onResolve={() => {
          setSwalProps({});
        }}
        backdrop={false}
        {...swalProps}
        customClass="custom-swal"
      />
      {masterLayoutState.contactList?.contactLists.map((contact, index) => (
        <div className="m-2 ">
          <div className="d-flex align-items-center" key={index}>
            <div className="mx-1 my-2">
              <img
                src={contact.iconurl}
                alt="Icon"
                style={{ width: "3rem", height: "3rem" }}
              />
            </div>
            <div className="d-flex flex-column">
              <div
                style={{
                  color: "#0080FF",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() =>
                  handleContactClick(contact.directurl, contact.contacttype)
                }
              >
                {contact.directurl}
              </div>
              <div>
                {contact.telno}{" "}
                <i
                  className="bi bi-copy"
                  onClick={() => {
                    if (sessionStorage.getItem("platform") === "mobile") {
                      console.log(`clipboard: ${contact.telno}`);
                      CopyToClipboard(`${contact.telno}`, setSwalProps, intl);
                    } else {
                      CopyToClipboard(`${contact.telno}`, setSwalProps, intl);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
      <Dialog open={open} onClose={handleClose}>
        <div
          className="text-font3"
          style={{
            padding: "20px",
            backgroundColor: "#1c1e23",
            color: "white",
          }}
        >
          <p> {intl.formatMessage({ id: "openCustomerService" })}</p>
          <div
            style={{ color: "#f5be09", textAlign: "end" }}
            onClick={handlNew}
          >
            {intl.formatMessage({ id: "confirm" })}
          </div>
        </div>
      </Dialog>
    </Modal>
  );
};
